import {
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
} from '@mui/material';
import React from 'react'

import { useTranslation } from "react-i18next";

interface DeleteDialogProps {
    type: "user" | "acc" | "announcement",
    selectedName: string | undefined,
    selectedId: string
    open: boolean,
    onClose: () => void,
    handleDelete: (id: string) => void,
}

export default function DeleteDialog(props: DeleteDialogProps) {
    const {t} = useTranslation()

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='md'
        >
            <DialogTitle id="alert-dialog-title">{t("deleteDialog.confirmDelete")}{t(`deleteDialog.type:${props.type}` as unknown as TemplateStringsArray)}{props.selectedName}?</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("deleteDialog.reminder")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    {t("deleteDialog.no")}
                </Button>
                <Button onClick={() => props.handleDelete(props.selectedId)} color="primary" autoFocus>
                    {t("deleteDialog.yes")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}